

































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import 'vue-datetime/dist/vue-datetime.css';

export default Vue.extend({
  components: {
    pxButton,
    pxCard,
  },

  data() {
    return {
      creating: true,
      pushing: false,
    };
  },

  computed: {
    ...mapGetters({
      examinationBoard: 'currentExaminationBoard',
    }),
  },

  async created() {
    this.creating = this.$route.name === 'examination_board_create';
    if (this.creating) {
      this.$store.commit('SET_EMPTY_EXAMINATION_BOARD');
    } else {
      let examinationBoardId = parseInt(this.$route.params.examinationBoardId);
      await this.$store.dispatch('PULL_EXAMINATION_BOARD', examinationBoardId);
      //TODO no examination board found
    }
  },

  methods: {
    pushExaminationBoard: async function() {
      //TODO check if examination board already exists
      if (this.pushing === false) {
        this.pushing = true;
        let error;
        try {
          await this.$store.dispatch(
            'PUSH_EXAMINATION_BOARD',
            this.examinationBoard,
          );
        } catch (e) {
          error = e;
          if (e.message.includes('unique constraint')) {
            alert(`Essa banca já existe!`);
          }
        }
        this.pushing = false;
        if (!error) this.$router.push(`/bancas`);
      }
    },
    goHome() {
      this.$router.push('/bancas');
    },
  },
});
